define 'controller/ServiceController', ['jquery'], ($) ->
  class ServiceController

    constructor: (@$el) ->
      @_initAccordion()
      @_initMondialRelais()

    _initAccordion: ->
      $ ->
        _openAccordionTopic(window.location.hash, false, false)

        $('#serviceTopics').on 'click', '.headline, .collapse', (e) ->
          currentAnchor = $(this).closest('.topic').attr('id')
          if $(e.target).closest('.topic').is('.active')
            _closeAccordionTopics(true)
          else
            _closeAccordionTopics(false)
            _openAccordionTopic('#' + currentAnchor, true, true )
          
        $('.serviceLink').on 'click', (e) ->
          anchor = $(this).closest('a')
          if anchor.attr('href')
            currentPathname = anchor.attr('href').split('#')[0]
            currentHash = '#' + anchor.attr('href').split('#')[1]
        
          if currentPathname == window.location.pathname
            e.preventDefault()
            _closeAccordionTopics(false)
            _openAccordionTopic(currentHash, false, true)

    
    _openAccordionTopic = (selector, showAnimation, scrollAnimation) ->
      openAnchor = $(selector)
      if openAnchor.offset()
        _changeAnchorInUrl(selector)
        $(selector).addClass 'active'
        $(selector + ' .headline').addClass 'active'
        $(selector + ' .collapse').removeClass 'plus'
        
        if showAnimation
          $(selector + ' .content').slideDown().addClass 'open'
        else
          $(selector + ' .content').slideDown(0).addClass 'open'
          
        if scrollAnimation
          $('html, body').animate({scrollTop: $(selector).offset().top})
        else
          $(document).scrollTop($(selector).offset().top)

      
    _closeAccordionTopics = (showAnimation) ->
      $('#serviceTopics .topic').removeClass 'active'
      $('#serviceTopics .topic .headline').removeClass 'active'
      $('#serviceTopics .topic .collapse').addClass 'plus'
      if showAnimation
        $('#serviceTopics .topic .content').slideUp().removeClass 'open'
      else
        $('#serviceTopics .topic .content').slideUp(0).removeClass 'open'

    _changeAnchorInUrl = (selector) ->
      x = window.scrollX
      y = window.scrollY
      window.location.hash = selector
      window.scrollTo(x, y)

    _initMondialRelais: ->
      apiKey = $(@.$el).attr('data-google-maps-api-key')
      if $('#Zone_Widget').length
        require ['//maps.googleapis.com/maps/api/js?sensor=false&key=' + apiKey], ->
          require ['//widget.mondialrelay.com/parcelshop-picker/jquery.plugin.mondialrelay.parcelshoppicker.min.js'], ->
            $('#Zone_Widget').MR_ParcelShopPicker Target: '#Zone_Widget', Brand: 'WT      ', Country: 'FR', EnableGmap: true